import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  loading = false;
  startTime: number | null = null;
  duration: number | null = null;

  constructor() {
  }

  startLoading(): void {
    this.loading = true;
    this.startTime = Date.now();
  }

  stopLoading(): void {
    this.loading = false;
    this.duration = (Date.now() - (this.startTime ?? 0)) / 1000.0;
  }

  isLoading(): boolean {
    return this.loading;
  }

  getDuration(): number | null {
    return this.duration;
  }
}
